import axios from "axios";


export const getCheckoutUrl = async () => {
    return await axios.post<{ url: string }>('/stripe/create-checkout-session');
}